export default {
	init() {
		let closes = document.querySelectorAll('.js-close-alert');

		if (closes) {
			closes.forEach((close) => {
				close.addEventListener('click', (event) => {
					let activeModal = document.querySelector('.js-alert'),
						activeOverlay = document.querySelector('.js-alert-overlay');

					activeModal.classList.add('c-alert-modal--fade-out');
					activeOverlay.classList.add('c-alert-modal-overlay--fade-out');

					event.preventDefault();
					// location.reload();
				});
			});
		}
	}
}
